import { CartUpdateEvent } from '@theme/events';

const SOURCE_ID = 'cm-bundle-upgrade';

let isProcessing = false;

function readBundleConfig() {
  const raw = (typeof window !== 'undefined' && window.CmBundleConfig) || {};
  const bundleVariantId = Number(raw.bundleVariantId);
  const partVariantIds = Array.isArray(raw.partVariantIds)
    ? raw.partVariantIds.map(Number).filter((n) => Number.isFinite(n) && n > 0)
    : [];
  const bonusVariantIds = Array.isArray(raw.bonusVariantIds)
    ? raw.bonusVariantIds.map(Number).filter((n) => Number.isFinite(n) && n > 0)
    : [];

  if (!Number.isFinite(bundleVariantId) || bundleVariantId <= 0) return null;
  if (partVariantIds.length < 2) return null;

  return { bundleVariantId, partVariantIds, bonusVariantIds };
}

async function fetchCart() {
  const res = await fetch(`${Theme.routes.cart_url}.js`, {
    headers: { Accept: 'application/json' },
  });
  return res.json();
}

function getCartSectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

async function commitUpdate(updates) {
  const sectionIds = getCartSectionIds();
  const body = { updates };
  if (sectionIds.length) body.sections = sectionIds.join(',');

  const res = await fetch(`${Theme.routes.cart_update_url}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  const cart = await res.json();

  document.dispatchEvent(
    new CartUpdateEvent(cart, SOURCE_ID, {
      source: SOURCE_ID,
      sections: cart.sections,
    })
  );

  return cart;
}

async function applyBundleUpgrade(event) {
  if (isProcessing) return;
  if (event?.detail?.data?.source === SOURCE_ID) return;

  const config = readBundleConfig();
  if (!config) return;

  const cart = await fetchCart();
  const variantQuantities = new Map(cart.items.map((item) => [item.variant_id, item.quantity]));

  const { partVariantIds, bundleVariantId, bonusVariantIds } = config;
  const hasAllParts = partVariantIds.every((id) => variantQuantities.has(id));
  const hasBundle = variantQuantities.has(bundleVariantId);

  if (hasAllParts && !hasBundle) {
    isProcessing = true;
    try {
      const updates = { [bundleVariantId]: 1 };
      for (const id of partVariantIds) updates[id] = 0;
      for (const id of bonusVariantIds) {
        if (!variantQuantities.has(id)) updates[id] = 1;
      }
      await commitUpdate(updates);
    } finally {
      isProcessing = false;
    }
    return;
  }

  if (hasBundle) {
    const missingBonuses = bonusVariantIds.filter((id) => !variantQuantities.has(id));
    if (missingBonuses.length === 0) return;

    isProcessing = true;
    try {
      const updates = {};
      for (const id of missingBonuses) updates[id] = 1;
      await commitUpdate(updates);
    } finally {
      isProcessing = false;
    }
  }
}

document.addEventListener('cart:update', applyBundleUpgrade);
document.addEventListener('DOMContentLoaded', () => applyBundleUpgrade());
